import { useSelector, useDispatch } from 'react-redux';
import boostingSlice from './boostingSlice';

function useBoosting() {
    const { boosting } = useSelector((state) => {
        return state.boosting;
    });
    const dispatch = useDispatch();
  
    function setBoosting(boosting) {
      dispatch(boostingSlice.actions.setBoosting(boosting));
    }
  
    return { boosting, setBoosting };
}

export default useBoosting;